// transfer object for the Station model to be submitted to server
export class StationDTO {

  equipment: string[]
  defaultExerciseId: number
  side: string | null
  defaultFeedbackLevelKey: string
  defaultFeedbackVerbosity: string
  displayLocale: string
  allowAnonymousLogin: boolean
  position: number
  screensaver: any
  audioHintsEnabled: boolean
  visualHintsEnabled: boolean
  exerciseTimeoutEnabled: boolean
  congratulationMessage: string | null
  displayName: string

  constructor (attributes) {
    Object.assign(this, attributes)
    if (this.side === 'alternating') {
      this.side = null
    }
    if (!this.congratulationMessage) {
      delete (this as any).congratulationMessage
    }
  }
}
